/**
 *
 * @type {Element}
 */
const button = document.querySelector( '#scroll-to-top' );


/**
 *
 */
const setupScrollToTop = () =>
{
	if (button instanceof Element) {
		
		button.addEventListener( 'click', () =>
		{
			window.scrollTo( {
				top:      0,
				behavior: 'smooth'
			} );
		} );

		window.addEventListener( 'scroll', showHideButton );
		showHideButton();
	}
};


/**
 *
 */
const showHideButton = () =>
{
	if (button instanceof Element) {

		if (window.scrollY > 300) {
			button.classList.add( 'active' );
		} else {
			button.classList.remove( 'active' );
		}
	}
};


export default setupScrollToTop;